import React from 'react'

const Offers = () => {
  return (
    <div className="offers">
        <style>
            {`
            .offers{
            margin:2vh;
            height:40vh;
            }
            `}
        </style>
        <h2>There are no offers available at the moment.</h2>
      </div>
  )
}

export default Offers;
